

import React, { useState } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, Collapse, Typography, Container } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
// Company
import CompanyIndex from './components/pages/company/Index';
import CompanyCreate from "./components/pages/company/Create";
import CompanyEdit from "./components/pages/company/Edit";
// Branch
import BranchIndex from './components/pages/branch/Index';
import BranchCreate from "./components/pages/branch/Create";
import BranchEdit from "./components/pages/branch/Edit";
// Category
import CategoryIndex from './components/pages/category/Index';
import CategoryCreate from "./components/pages/category/Create";
import CategoryEdit from "./components/pages/category/Edit";
// PGCategory
import PGCategoryIndex from './components/pages/pgcategory/Index';
import PGCategoryCreate from "./components/pages/pgcategory/Create";
import PGCategoryEdit from "./components/pages/pgcategory/Edit";
// Item Group
import ItemGroupIndex from './components/pages/itemgroup/Index';
import ItemGroupCreate from "./components/pages/itemgroup/Create";
import ItemGroupEdit from "./components/pages/itemgroup/Edit";
// Item 
import ItemIndex from './components/pages/item/Index';
import ItemCreate from "./components/pages/item/Create";
import ItemEdit from "./components/pages/item/Edit";
//User
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";
//Role
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";
//SalesMan
import SalesManCreate from "./components/pages/SalesMan/Create";
import SalesManIndex from "./components/pages/SalesMan/Index";
import SalesManEdit from "./components/pages/SalesMan/Edit";
//Purchase
import PurchaseIndex from "./components/pages/purchase/Index";
import PurchaseCreate from "./components/pages/purchase/Create";
import PurchaseEdit from "./components/pages/purchase/Edit";
import PurchaseDetails from "./components/pages/purchase/Details";
//PurchaseReturn
import PurchaseReturnIndex from "./components/pages/purchasereturn/Index";
import PurchaseReturnCreate from "./components/pages/purchasereturn/Create";
import PurchaseReturnEdit from "./components/pages/purchasereturn/Edit";
import PurchaseReturnDetails from "./components/pages/purchasereturn/Details";
//Sale
import SaleIndex from "./components/pages/sale/Index";
import SaleCreate from "./components/pages/sale/Create";
import SaleEdit from "./components/pages/sale/Edit";
import SaleDetails from "./components/pages/sale/Details";
//Sale Return
import SaleReturnIndex from "./components/pages/salereturn/Index";
import SaleReturnCreate from "./components/pages/salereturn/Create";
import SaleReturnEdit from "./components/pages/salereturn/Edit";
import SaleReturnDetails from "./components/pages/salereturn/Details";
//Stock Transfer
import StockTransferIndex from "./components/pages/stocktransfer/Index";
import StockTransferCreate from "./components/pages/stocktransfer/Create";
import StockTransferEdit from "./components/pages/stocktransfer/Edit";
import StockIn from "./components/pages/stocktransfer/StockIn";
import StockInDetail from "./components/pages/stocktransfer/StockInDetail";
import StockTransferDetails from "./components/pages/stocktransfer/Details";
import StockInCreate from "./components/pages/stocktransfer/StockInCreate";
import StockTransferEcommCreate from "./components/pages/stocktransfer/EcommCreate";
import StockInPending from "./components/pages/stocktransfer/StockInPending";

// Replacement
import ReplacementIndex from "./components/pages/replacement/Index";
import ReplacementCreate from "./components/pages/replacement/Create";
import ReplacementEdit from "./components/pages/replacement/Edit";
import ReplacementDetails from "./components/pages/replacement/Details";
// Report
import DailySalesSummary from "./components/pages/Report/DailySalesSummary";
import Stock from "./components/pages/Report/Stock";
import StockTransfer from "./components/pages/Report/StockTransfer";
import CutomerDetails from "./components/pages/Report/CustomerDetails";
import PurchaseSummary from "./components/pages/Report/PurchaseSummary";
import DailySalesPaymentWise from "./components/pages/Report/DailySalesPaymentWise";
import KPIReport from "./components/pages/Report/KPIReport";
import BestSellerSales from "./components/pages/Report/BestSellerSales";
import RepairORReplacement from "./components/pages/Report/RepairORReplacement";
import StockTransferIn from "./components/pages/Report/StockTransferIn";
import StockTransferOut from "./components/pages/Report/StockTransferOut"
// OtherReport
import OtherDailySalesSummary from "./components/pages/otherbranch/OtherDailySalesSummary";
import OtherPurchaseSummary from "./components/pages/otherbranch/OtherPurchaseSummary";
import OtherStock from "./components/pages/otherbranch/OtherStock";
import AjioStock from "./components/pages/otherbranch/AjioStock";
import OtherStockTransfer from "./components/pages/otherbranch/OtherStockTransfer";
import OtherDSSPaymentWise from "./components/pages/otherbranch/OtherDSSPaymentWise";
import OtherKPIReport from "./components/pages/otherbranch/OtherKPIReport";
import OtherRepairORReplacement from "./components/pages/otherbranch/OtherRepairORReplacement";
import OtherCustomerDetails from "./components/pages/otherbranch/OtherCustomerDetails";
import OtherStockTransferIn from "./components/pages/otherbranch/OtherStockTransferIn"
import OtherStockTransferOut from "./components/pages/otherbranch/OtherStockTransferOut"
//repairandreplacement
import RepairAndReplacementIndex from "./components/pages/repairandreplacement/Index";
import RepairAndReplacementCreate from "./components/pages/repairandreplacement/Create";
import RepairAndReplacementDetails from "./components/pages/repairandreplacement/Details";
import RepairAndReplacementEdit from "./components/pages/repairandreplacement/Edit";

import Home from "./components/pages/Home";
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';
import LodingComponent from "./loding";
import { AuthProvider, useAuth } from "./AuthContext";
import Logout from "./Logout";
import SessionTimeout from "./SessionTimeout";

import InventoryIcon from '@mui/icons-material/Inventory';
import PaymentsIcon from '@mui/icons-material/Payments';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentIcon from '@mui/icons-material/Payment';
import WalletIcon from '@mui/icons-material/Wallet';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LabelIcon from '@mui/icons-material/Label';

import StoreIcon from '@mui/icons-material/Store';
import CategoryIcon from '@mui/icons-material/Category';
import PersonIcon from '@mui/icons-material/Person';
import Person2Icon from '@mui/icons-material/Person2';
import ContactsIcon from '@mui/icons-material/Contacts';
import ListAltIcon from '@mui/icons-material/ListAlt';
import GroupWorkIcon from '@mui/icons-material/GroupWork';

import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ArticleIcon from '@mui/icons-material/Article';

import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import SecurityIcon from '@mui/icons-material/Security';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import BuildIcon from '@mui/icons-material/Build';

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [otherOpen, setOtherOpen] = useState(false);
  const [userOpen, setuserOpen] = useState(false);
  const [itemOpen, setItemOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMasterClick = () => {
    setMasterOpen(!masterOpen);
  };

  const handleReportClick = () => {
    setReportOpen(!reportOpen);
  };

  const handleOtherClick = () => {
    setOtherOpen(!otherOpen);
  };


  const handleUserClick = () => {
    setuserOpen(!userOpen);
  };

  const handleItemClick = () => {
    setItemOpen(!itemOpen);
  };

  const { companyName, companyId, isSuperAdmin, superCompanyId, roleName, branchId } = useAuth();

  return (
    <Router>
      <AuthProvider>
        <SessionTimeout />
        <AppBar position="static" style={{ backgroundColor: '#27445D', height: '55px' }}>
          <Toolbar style={{ minHeight: '55px', padding: '0 24px', position: 'relative' }}>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
              <MenuIcon />
            </IconButton>

            <Typography variant="h6" component="div" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <Link to="/Home" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
                  <FiHome style={{ marginRight: '8px' }} />
                  <Typography variant="h5" className="dual-text" component="div" style={{ marginLeft: '16px', fontWeight: 'bolder', position: 'relative' }}>
                    {companyName}

                  </Typography>
                </Link>
              </div>
              <div className="white-icon" style={{ marginTop: '5px' }}>
                <Logout />
              </div>
            </Typography>
          </Toolbar>
        </AppBar>
        {roleName !== "Counter" && (
          <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}>

            <h4 className="dual-tone-text" style={{ fontWeight: 'bolder', marginTop: '18px', marginLeft: '10px' }}> {companyName}</h4>
            <List>
              <ListItem button component={NavLink} to="/Home" activeClassName="selected" onClick={handleDrawerClose}>
                <ListItemText primary="HOME" />
              </ListItem>

              {roleName != "Accounts" && (
                <ListItem button onClick={handleMasterClick}>
                  <ListItemText primary="MASTER" />
                  {masterOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
              )}


              <Collapse in={masterOpen} timeout="auto" unmountOnExit>
                <List style={{ paddingLeft: '16px' }}>
                  <ListItem button component={NavLink} to="/BranchIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <StoreIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="Branch" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  {roleName == "SuperAdmin" && (
                    <ListItem button component={NavLink} to="/CategoryIndex" activeClassName="selected" onClick={handleDrawerClose}>
                      <CategoryIcon style={{ color: 'darkcyan', height: '20px' }} /><ListItemText primary="Category" style={{ marginLeft: '3px' }} />
                    </ListItem>
                  )}

                  {roleName == "SuperAdmin" && (
                    <ListItem button component={NavLink} to="/PGCategoryIndex" activeClassName="selected" onClick={handleDrawerClose}>
                      <CategoryIcon style={{ color: 'darkseagreen', height: '20px' }} /><ListItemText primary="PG Category" style={{ marginLeft: '3px' }} />
                    </ListItem>
                  )}

                  {roleName == "SuperAdmin" && (
                    <ListItem button component={NavLink} to="/ItemGroupIndex" activeClassName="selected" onClick={handleDrawerClose}>
                      <GroupWorkIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Item Group" style={{ marginLeft: '3px' }} />
                    </ListItem>
                  )}

                  <ListItem button component={NavLink} to="/ItemIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <LabelIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Item" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/SalesManIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <ContactsIcon style={{ color: 'red', height: '20px' }} /><ListItemText primary="Sales Man" style={{ marginLeft: '3px' }} />
                  </ListItem>
                </List>
              </Collapse>

              {roleName != "Accounts" && (
                <ListItem button onClick={handleItemClick}>
                  <ListItemText primary="TRANSACTION" />
                  {itemOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
              )}


              <Collapse in={itemOpen} timeout="auto" unmountOnExit>
                <List style={{ paddingLeft: '16px' }}>
                  <ListItem button component={NavLink} to="/PurchaseIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <InventoryIcon style={{ color: 'green', height: '20px' }} /><ListItemText primary="Purchase" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/PurchaseReturnIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <AssignmentReturnIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="Purchase Return" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/SaleIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <AddShoppingCartIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Sale" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/SaleReturnIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <RemoveShoppingCartIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Sale Return" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/StockTransferIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <MoveUpIcon style={{ color: 'darkcyan', height: '20px' }} /><ListItemText primary="Stock Out" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/StockIn" activeClassName="selected" onClick={handleDrawerClose}>
                    <MoveDownIcon style={{ color: 'darkgreen', height: '20px' }} /><ListItemText primary="Stock In" style={{ marginLeft: '3px' }} />
                  </ListItem>
                  <ListItem button component={NavLink} to="/RepairAndReplacementIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <BuildIcon style={{ color: 'red', height: '20px' }} /><ListItemText primary="Repair / Replacement" style={{ marginLeft: '3px' }} />
                  </ListItem>

                </List>
              </Collapse>

              {roleName != "Accounts" && (
                <ListItem button onClick={handleReportClick}>
                  <ListItemText primary="REPORT" />
                  {reportOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
              )}

              <Collapse in={reportOpen} timeout="auto" unmountOnExit>
                <List style={{ paddingLeft: '16px' }}>
                  <ListItem button component={NavLink} to="/DailySalesSummary" activeClassName="selected" onClick={handleDrawerClose}>
                    <InventoryIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="DSS" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/DailySalesPaymentWise" activeClassName="selected" onClick={handleDrawerClose}>
                    <PaymentsIcon style={{ color: 'darkseagreen', height: '20px' }} /><ListItemText primary="DSS Payment Wise" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/KPIReport" activeClassName="selected" onClick={handleDrawerClose}>
                    <ArticleIcon style={{ color: 'red', height: '20px' }} /><ListItemText primary="KPI Report" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/RepairORReplacement" activeClassName="selected" onClick={handleDrawerClose}>
                    <BuildIcon style={{ color: '#B03052', height: '20px' }} /><ListItemText primary="Repair / Replacement" style={{ marginLeft: '3px' }} />
                  </ListItem>


                  <ListItem button component={NavLink} to="/BestSellerSales" activeClassName="selected" onClick={handleDrawerClose}>
                    <LibraryBooksIcon style={{ color: 'green', height: '20px' }} /><ListItemText primary="Best Seller Sales" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/Stock" activeClassName="selected" onClick={handleDrawerClose}>
                    <SummarizeIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Consolidated Stock" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/PurchaseSummary" activeClassName="selected" onClick={handleDrawerClose}>
                    <LibraryBooksIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Purchase Summary" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/StockTransferIn" activeClassName="selected" onClick={handleDrawerClose}>
                    <MoveDownIcon style={{ color: 'darkgreen', height: '20px' }} /><ListItemText primary="Stock Transfer IN" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/StockTransferOut" activeClassName="selected" onClick={handleDrawerClose}>
                    <MoveUpIcon style={{ color: '#9d30b0ff', height: '20px' }} /><ListItemText primary="Stock Transfer Out" style={{ marginLeft: '3px' }} />
                  </ListItem>


                  <ListItem button component={NavLink} to="/CutomerDetails" activeClassName="selected" onClick={handleDrawerClose}>
                    <PersonIcon style={{ color: 'darkcyan', height: '20px' }} /><ListItemText primary="Customer Data" style={{ marginLeft: '3px' }} />
                  </ListItem>


                </List>
              </Collapse>

              {(roleName == "Accounts" || roleName == "SuperAdmin" || companyId == '1009') && (
                <ListItem button onClick={handleOtherClick}>
                  <ListItemText primary="BRANCH REPORT" />
                  {otherOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
              )}

              <Collapse in={otherOpen} timeout="auto" unmountOnExit>
                <List style={{ paddingLeft: '16px' }}>
                  <ListItem button component={NavLink} to="/OtherDailySalesSummary" activeClassName="selected" onClick={handleDrawerClose}>
                    <InventoryIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="DSS" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OtherDSSPaymentWise" activeClassName="selected" onClick={handleDrawerClose}>
                    <PaymentsIcon style={{ color: 'darkseagreen', height: '20px' }} /><ListItemText primary="DSS Payment Wise" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OtherKPIReport" activeClassName="selected" onClick={handleDrawerClose}>
                    <ArticleIcon style={{ color: 'red', height: '20px' }} /><ListItemText primary="KPI Report" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OtherRepairORReplacement" activeClassName="selected" onClick={handleDrawerClose}>
                    <BuildIcon style={{ color: '#B03052', height: '20px' }} /><ListItemText primary="Repair / Replacement" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/BestSellerSales" activeClassName="selected" onClick={handleDrawerClose}>
                    <LibraryBooksIcon style={{ color: 'green', height: '20px' }} /><ListItemText primary="Best Seller Sales" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OtherStock" activeClassName="selected" onClick={handleDrawerClose}>
                    <SummarizeIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Consolidated Stock" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OtherPurchaseSummary" activeClassName="selected" onClick={handleDrawerClose}>
                    <LibraryBooksIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Purchase Summary" style={{ marginLeft: '3px' }} />
                  </ListItem>
                  {(roleName != "Accounts") && (
                    <ListItem button component={NavLink} to="/AjioStock" activeClassName="selected" onClick={handleDrawerClose}>
                      <ListAltIcon style={{ color: 'darkcyan', height: '20px' }} /><ListItemText primary="AJIO Stock" style={{ marginLeft: '3px' }} />
                    </ListItem>
                  )}
                  {/* <ListItem button component={NavLink} to="/OtherStockTransfer" activeClassName="selected" onClick={handleDrawerClose}>
                    <ArticleIcon style={{ color: 'darkgreen', height: '20px' }} /><ListItemText primary="Stock Transfer" style={{ marginLeft: '3px' }} />
                  </ListItem> */}

                  <ListItem button component={NavLink} to="/OtherStockTransferIn" activeClassName="selected" onClick={handleDrawerClose}>
                    <MoveDownIcon style={{ color: 'darkgreen', height: '20px' }} /><ListItemText primary="Stock Transfer IN" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OtherStockTransferOut" activeClassName="selected" onClick={handleDrawerClose}>
                    <MoveUpIcon style={{ color: '#9d30b0ff', height: '20px' }} /><ListItemText primary="Stock Transfer Out" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/OtherCustomerDetails" activeClassName="selected" onClick={handleDrawerClose}>
                    <PersonIcon style={{ color: 'darkcyan', height: '20px' }} /><ListItemText primary="Customer Data" style={{ marginLeft: '3px' }} />
                  </ListItem>

                </List>
              </Collapse>

              <ListItem button onClick={handleUserClick}>
                <ListItemText primary="USER" />
                {userOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>

              <Collapse in={userOpen} timeout="auto" unmountOnExit>
                <List style={{ paddingLeft: '16px' }}>

                  {roleName == "SuperAdmin" && (

                    <ListItem button component={NavLink} to="/UserIndex" activeClassName="selected" onClick={handleDrawerClose}>
                      <PeopleAltIcon style={{ color: 'blueviolet', height: '20px' }} /><ListItemText primary="User" style={{ marginLeft: '3px' }} />
                    </ListItem>
                  )}

                  {roleName == "SuperAdmin" && (
                    <ListItem button component={NavLink} to="/RoleIndex" activeClassName="selected" onClick={handleDrawerClose}>
                      <AccessibilityIcon style={{ color: 'darkorange', height: '20px' }} /><ListItemText primary="Role" style={{ marginLeft: '3px' }} />
                    </ListItem>
                  )}

                  <ListItem button component={NavLink} to="/PasswordChange" activeClassName="selected" onClick={handleDrawerClose}>
                    <SecurityIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Change Password" style={{ marginLeft: '3px' }} />
                  </ListItem>
                </List>
              </Collapse>

            </List>
          </Drawer>
        )}

        <Container maxWidth="xl">
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/Home" exact component={Home} />
            {/* Company */}
            <Route path="/CompanyIndex" component={CompanyIndex} />
            <Route path="/CompanyCreate" component={CompanyCreate} />
            <Route path="/CompanyEdit/:id" component={CompanyEdit} />
            {/* Branch */}
            <Route path="/BranchIndex" component={BranchIndex} />
            <Route path="/BranchCreate" component={BranchCreate} />
            <Route path="/BranchEdit/:id" component={BranchEdit} />
            {/* Category */}
            <Route path="/CategoryIndex" component={CategoryIndex} />
            <Route path="/CategoryCreate" component={CategoryCreate} />
            <Route path="/CategoryEdit/:id" component={CategoryEdit} />
            {/* PGCategory */}
            <Route path="/PGCategoryIndex" component={PGCategoryIndex} />
            <Route path="/PGCategoryCreate" component={PGCategoryCreate} />
            <Route path="/PGCategoryEdit/:id" component={PGCategoryEdit} />
            {/* ItemGroup */}
            <Route path="/ItemGroupIndex" component={ItemGroupIndex} />
            <Route path="/ItemGroupCreate" component={ItemGroupCreate} />
            <Route path="/ItemGroupEdit/:id" component={ItemGroupEdit} />
            {/* Item */}
            <Route path="/ItemIndex" component={ItemIndex} />
            <Route path="/ItemCreate" component={ItemCreate} />
            <Route path="/ItemEdit/:id" component={ItemEdit} />
            {/* User */}
            <Route path="/UserIndex" component={UserIndex} />
            <Route path="/UserCreate" component={UserCreate} />
            <Route path="/UserEdit/:id" component={UserEdit} />
            <Route path="/UserDetail/:id" component={UserDetail} />
            <Route path="/PasswordChange" component={PasswordChange} />
            {/* Role */}
            <Route path="/RoleIndex" component={RoleIndex} />
            <Route path="/RoleDetail/:id" component={RoleDetail} />
            {/* SalesMan */}
            <Route path="/SalesManIndex" component={SalesManIndex} />
            <Route path="/SalesManCreate" component={SalesManCreate} />
            <Route path="/SalesManEdit/:id" component={SalesManEdit} />
            {/* Purchase */}
            <Route path="/PurchaseIndex" component={PurchaseIndex} />
            <Route path="/PurchaseCreate" component={PurchaseCreate} />
            <Route path="/PurchaseEdit/:id" component={PurchaseEdit} />
            <Route path="/PurchaseDetails/:id" component={PurchaseDetails} />
            {/* Purchase Return*/}
            <Route path="/PurchaseReturnIndex" component={PurchaseReturnIndex} />
            <Route path="/PurchaseReturnCreate" component={PurchaseReturnCreate} />
            <Route path="/PurchaseReturnEdit/:id" component={PurchaseReturnEdit} />
            <Route path="/PurchaseReturnDetails/:id" component={PurchaseReturnDetails} />
            {/* Sale */}
            <Route path="/SaleIndex" component={SaleIndex} />
            <Route path="/SaleCreate" component={SaleCreate} />
            <Route path="/SaleEdit/:id" component={SaleEdit} />
            <Route path="/SaleDetails/:id" component={SaleDetails} />
            {/* Sale Return*/}
            <Route path="/SaleReturnIndex" component={SaleReturnIndex} />
            <Route path="/SaleReturnCreate" component={SaleReturnCreate} />
            <Route path="/SaleReturnEdit/:id" component={SaleReturnEdit} />
            <Route path="/SaleReturnDetails/:id" component={SaleReturnDetails} />
            {/* Stock Transfer*/}
            <Route path="/StockTransferIndex" component={StockTransferIndex} />
            <Route path="/StockTransferCreate" component={StockTransferCreate} />
            <Route path="/StockTransferEdit/:id" component={StockTransferEdit} />
            <Route path="/StockIn" component={StockIn} />
            <Route path="/StockInDetail/:id" component={StockInDetail} />
            <Route path="/StockTransferDetails/:id" component={StockTransferDetails} />
            <Route path="/StockInCreate" component={StockInCreate} />
            <Route path="/StockTransferEcommCreate" component={StockTransferEcommCreate} />
            <Route path="/StockInPending/:id" component={StockInPending} />
            {/* Replacement*/}
            <Route path="/ReplacementIndex" component={ReplacementIndex} />
            <Route path="/ReplacementCreate" component={ReplacementCreate} />
            <Route path="/ReplacementEdit/:id" component={ReplacementEdit} />
            <Route path="/ReplacementDetails/:id" component={ReplacementDetails} />
            {/* Report*/}
            <Route path="/DailySalesSummary" component={DailySalesSummary} />
            <Route path="/Stock" component={Stock} />
            <Route path="/StockTransfer" component={StockTransfer} />
            <Route path="/CutomerDetails" component={CutomerDetails} />
            <Route path="/PurchaseSummary" component={PurchaseSummary} />
            <Route path="/DailySalesPaymentWise" component={DailySalesPaymentWise} />
            <Route path="/KPIReport" component={KPIReport} />
            <Route path="/BestSellerSales" component={BestSellerSales} />
            <Route path="/RepairORReplacement" component={RepairORReplacement} />
            <Route path="/StockTransferIn" component={StockTransferIn} />
            <Route path="/StockTransferOut" component={StockTransferOut} />
            {/* Other Report*/}
            <Route path="/OtherDailySalesSummary" component={OtherDailySalesSummary} />
            <Route path="/OtherPurchaseSummary" component={OtherPurchaseSummary} />
            <Route path="/OtherStock" component={OtherStock} />
            <Route path="/AjioStock" component={AjioStock} />
            <Route path="/OtherStockTransfer" component={OtherStockTransfer} />
            <Route path="/OtherDSSPaymentWise" component={OtherDSSPaymentWise} />
            <Route path="/OtherKPIReport" component={OtherKPIReport} />
            <Route path="/OtherRepairORReplacement" component={OtherRepairORReplacement} />
            <Route path="/OtherCustomerDetails" component={OtherCustomerDetails} />
            <Route path="/OtherStockTransferIn" component={OtherStockTransferIn}/>
            <Route path="/OtherStockTransferOut" component={OtherStockTransferOut}/>
            {/* RepairAndReplacement*/}
            <Route path="/RepairAndReplacementIndex" component={RepairAndReplacementIndex} />
            <Route path="/RepairAndReplacementCreate" component={RepairAndReplacementCreate} />
            <Route path="/RepairAndReplacementDetails/:id" component={RepairAndReplacementDetails} />
            <Route path="/RepairAndReplacementEdit/:id" component={RepairAndReplacementEdit} />
          </Switch>
        </Container>


      </AuthProvider >
    </Router>
  );
};

export default App;

